import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import runtimeConfig from './runtimeConfig';
import Main from '../app/MainComponent';
import FullUploadProduct from '../app/new-product/full-upload/flow/FullUploadProductContainer';
import FullUploadProductCustomisation from '../app/new-product/full-upload/flow/FullUploadProductCustomisationContainer';
import FullUpload from '../app/new-product/full-upload/flow/FullUploadContainer';
import Creation from '../app/new-product/creation/flow/CreationContainer';
import CreationTemplate from '../app/new-product/creation/flow/CreationTemplateContainer';
import HelpPage from '../app/help/HelpPageContainer';
import DashboardPage from '../app/dashboard/DashboardPageContainer';
import Placeholder from '../app/placeholder/PlaceholderPageComponent';
import InspirationPage from '../app/inspiration/InspirationPageComponent';
import AccessoriesRoutes from './AccessoriesRoutes';
import ApprovalRoutes from './ApprovalRoutes';
import SettingsPage from '../app/settings/SettingsPage';
import AddressUpload from '../app/bulk/AddressUpload.js';
import AccountRoutes from './AccountRoutes';
import ProductsRoutes from './ProductsRoutes';
import { RoutesHelper } from './RoutesHelper';

import { envUrl } from '../app/services/environment/EnvironmentService';

const componentMap = {
  FullUploadProductCustomisation,
  DashboardPage,
  FullUpload,
  Creation,
  CreationTemplate,
  FullUploadProduct,
  Main,
  HelpPage,
  InspirationPage,
  Placeholder,
  SettingsPage,
  AddressUpload,
};

function RouteSwitch(props) {
  const { isUserAndAccountConfigLoaded } = props.config;
  const { componentMapOverride } = props;
  const pages = componentMapOverride ? componentMapOverride(componentMap) : componentMap;
  const subrouteProps = { componentMapOverride };
  if (isUserAndAccountConfigLoaded === false) {
    return null;
  }

  return (
    <Switch>
      <Route
        exact
        path={envUrl('/products/create')}
        render={() => <pages.Creation {...props} runtimeConfig={runtimeConfig} />}
      />
      <Route
        path={envUrl('/products/create/:type')}
        render={() => <pages.CreationTemplate runtimeConfig={runtimeConfig} />}
      />
      <Route
        exact
        path={RoutesHelper.fullUpload()}
        render={() => <pages.FullUploadProduct runtimeConfig={runtimeConfig} />}
      />
      <Route exact path={RoutesHelper.fullUploadByType(':type')} component={pages.FullUploadProductCustomisation} />
      <Route
        path={RoutesHelper.fullUploadByTypeAndSize(':type', ':size')}
        component={pages.FullUploadProductCustomisation}
      />
      <Route exact path={envUrl('/products/guidelines')} component={pages.FullUpload} runtimeConfig={runtimeConfig} />

      <Route path={envUrl('/')}>
        <pages.Main {...props}>
          <Switch>
            <Route path={envUrl('/dashboard')} component={pages.DashboardPage} runtimeConfig={runtimeConfig} />
            <Route
              path={envUrl('/products')}
              render={() => <ProductsRoutes {...subrouteProps} />}
              runtimeConfig={runtimeConfig}
            />
            <Route path={envUrl('/accessories')} render={() => <AccessoriesRoutes {...subrouteProps} />} />
            <Route path={envUrl('/help')} component={pages.HelpPage} />
            <Route path={envUrl('/inspiration')} component={pages.InspirationPage} />
            <Route path={envUrl('/account')} render={() => <AccountRoutes {...subrouteProps} />} />
            <Route path={envUrl('/orders')} render={() => <pages.Placeholder name="orders" />} />
            <Route path={envUrl('/people')} render={() => <pages.Placeholder name="people" />} />
            <Route path={envUrl('/approvals')} render={() => <ApprovalRoutes {...subrouteProps} />} />
            <Route path={envUrl('/address-upload')} render={() => <AddressUpload {...subrouteProps} />} />
            <Route
              path={envUrl('/settings')}
              render={() => (
                <pages.SettingsPage
                  availableSettings={{
                    editableAccountSettings: props.config.editableAccountSettings,
                    availableStores: props.config.availableStores,
                  }}
                />
              )}
            />
            {/* This needs to be last as order is important for the redirect to behave as a catch-all-mistakes route */}
            <Route path={envUrl('/')}>
              <Redirect to={envUrl('/products/business-cards')} />
            </Route>
          </Switch>
        </pages.Main>
      </Route>
    </Switch>
  );
}

export const Routes = withRouter(RouteSwitch);
